<template>
  <div class="app-search-query">

    <input-title/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="'input-group-' + i"
        class="input-group">
        <el-autocomplete
          v-model="valueLocal[i]"
          v-bind="widgetOptions"
          :fetch-suggestions="querySearch"
          placeholder="ПОИСК"
          @keyup.enter.native="onEnterClicked"
          style="text-align: center; width: 100%"
          ref="input"
          :trigger-on-focus="false">
          <!--<i slot="prefix" class="el-input__icon el-icon-search"></i>-->
        </el-autocomplete>
      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import axios from 'axios';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
    };
  },

  methods: {

    querySearch(queryString, cb) {
      axios.get('objects/autocomplete', { params: { q: queryString } }).then((response) => {
        if (response.data) {
          const results = [];
          response.data.forEach((value) => {
            results.push({ value });
          });
          cb(results);
        }
      });
    },

    onEnterClicked() {
      this.$refs.input[0].suggestions = [];
    },

  },

};
</script>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppSearchQuery.vue